import type { RailwayProjectSummary } from '@cli-types/next-adapter/railway.js'

export function railwayProjectNameIsTaken(
  projects: RailwayProjectSummary[],
  candidate: string
): boolean {
  return projects.some((project) => project.name.toLowerCase() === candidate.toLowerCase())
}
